import Repository from '../Repository';

const url = '/faq';

export default {
    getLocalizedQuestions() {
        return Repository.get(`${url}/`);
    },
    getSpecificLocalizedQuestion(questionId) {
        return Repository.get(`${url}/${questionId}`);
    }
}
